/**
 * @file Password strength scoring for registration (pure domain).
 * Score 0–5 → fraca | boa | forte. Accept signup when score ≥ 3 (boa).
 *
 * Espelhado em supabase/functions/auth-signup/passwordStrength.ts
 * — rode passwordStrength.parity.test.ts ao alterar qualquer um dos dois.
 */

export type PasswordStrengthLevel = 'fraca' | 'boa' | 'forte';

export const PASSWORD_STRENGTH_SEGMENTS = 3;

export const PASSWORD_STRENGTH_LABEL: Record<PasswordStrengthLevel, string> = {
  fraca: 'Senha Fraca',
  boa: 'Senha Boa',
  forte: 'Senha Forte',
};

/** Returns 0–5: +1 length≥8, lower, upper, digit, special. */
export function scorePassword(password: string): number {
  let score = 0;
  if (password.length >= 8) score += 1;
  if (/[a-z]/.test(password)) score += 1;
  if (/[A-Z]/.test(password)) score += 1;
  if (/\d/.test(password)) score += 1;
  if (/[^A-Za-z0-9]/.test(password)) score += 1;
  return score;
}

export function passwordStrengthLevel(password: string): PasswordStrengthLevel {
  const score = scorePassword(password);
  if (score >= 5) return 'forte';
  if (score >= 3) return 'boa';
  return 'fraca';
}

export function isPasswordAcceptable(password: string): boolean {
  return passwordStrengthLevel(password) !== 'fraca';
}

/** Filled segments for the meter (1–3). Empty password → 0. */
export function passwordStrengthFilledSegments(password: string): number {
  if (!password) return 0;
  const level = passwordStrengthLevel(password);
  if (level === 'forte') return 3;
  if (level === 'boa') return 2;
  return 1;
}
